import React, { useState, useEffect } from 'react'
import "../../assets/style/eegisterProvider.css"
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Typography, Box } from '@mui/material';
import components from '../../components';
import BuyFundAssestsTable from '../../components/Table/BuyFundAssestsTable';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const BuyFundAssets = () => {
  const [BackDropState, setBackDropState] = useState(false);
  const [fundAssets, setFundAssets] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filter states
  const [market, setMarket] = useState('');
  const [instrument, setInstrument] = useState('');
  const [institutionName, setInstitutionName] = useState('');
  const [date, setDate] = useState('');
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });

  // Get all available fund assets from providers
  const fetchFundAssets = async () => {
    try {
      setLoading(true);
      setBackDropState(true);
      
      // Fetch all data units created by providers
      // TODO: Filter by the provider the subscriber is approved for
      // Need to implement: /fundSubscriber/getApprovedProvider endpoint
      const response = await ApiCall.SECURE_API.get('/dataunit/getAllDataunit');
      
      if (response.data.success) {
        const assets = response.data.data || [];
        setFundAssets(assets);
        setFilteredAssets(assets);
      } else {
        toast.error(response.data.message || 'Failed to load fund assets');
      }
    } catch (error) {
      console.error('Error fetching fund assets:', error);
      toast.error('Failed to load fund assets');
    } finally {
      setLoading(false);
      setBackDropState(false);
    }
  };

  // Filter fund assets based on selected criteria
  const applyFilters = () => {
    let filtered = [...fundAssets];

    if (market) {
      filtered = filtered.filter(asset => asset.market === market);
    }

    if (instrument) {
      filtered = filtered.filter(asset => asset.instrument === instrument);
    }

    if (institutionName) {
      filtered = filtered.filter(asset => 
        asset.providerData?.institutionName?.toLowerCase().includes(institutionName.toLowerCase()) ||
        asset.providerData?.institutionCode?.toLowerCase().includes(institutionName.toLowerCase())
      );
    }

    if (date) {
      filtered = filtered.filter(asset => {
        const assetDate = new Date(asset.createdAt);
        const now = new Date();
        const diffTime = Math.abs(now - assetDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        switch (date) {
          case '1D': return diffDays <= 1;
          case '1W': return diffDays <= 7;
          case '1M': return diffDays <= 30;
          case '3M': return diffDays <= 90;
          case '1Y': return diffDays <= 365;
          case '2Y': return diffDays <= 730;
          case '5Y': return diffDays <= 1825;
          default: return true;
        }
      });
    }

    if (priceRange.min !== '') {
      filtered = filtered.filter(asset => asset.price >= parseFloat(priceRange.min));
    }

    if (priceRange.max !== '') {
      filtered = filtered.filter(asset => asset.price <= parseFloat(priceRange.max));
    }

    setFilteredAssets(filtered);
  };

  // Clear all filters
  const clearFilters = () => {
    setMarket('');
    setInstrument('');
    setInstitutionName('');
    setDate('');
    setPriceRange({ min: '', max: '' });
    setFilteredAssets(fundAssets);
  };

  // Load fund assets on component mount
  useEffect(() => {
    fetchFundAssets();
  }, []);

  // Apply filters whenever filter values change
  useEffect(() => {
    applyFilters();
  }, [market, instrument, institutionName, date, priceRange]);

  return (
    <div style={{ width: "100%", backgroundColor: "#F3F4F8" }}>
      <components.Loader.Back_Drop state={BackDropState} />
      
      <div style={{ padding: "20px" }}>
        <Typography variant="h4" style={{ marginBottom: "20px", color: "#2c5aa0" }}>
          Select Fund Level
        </Typography>

        {/* Fund Assets Table */}
        <BuyFundAssestsTable
          data={filteredAssets}
          setBackDropState={setBackDropState}
          BackDropState={BackDropState}
        />
      </div>
    </div>
  );
};

export default BuyFundAssets;